import { schemes } from "@zeal/common";
import { z } from "zod";

export const signPartnerAgreementsSchema = z.object({
  accessToken: z.string(),
  partnerID: schemes.partnerID(),
  document_key: z.string(),
  signature: z.string(),
});

export type TSignPartnerAgreementsRequest = z.infer<
  typeof signPartnerAgreementsSchema
>;
